import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import "./NavBar.css";
import { NavLink } from "react-router-dom";
import useAuth from "./../../hook/useAuth";
const NavBar = () => {
  const { user, logout } = useAuth();
  const [show, setShow] = useState(false)
  const showDropdown = () => {
    setShow(!show)
  }
  const hideDropdown = () => {
    setShow(false)
  }
  const [cart, setCart] = useState([]);
  useEffect(() => {
    fetch('https://carame-cake-server-site.vercel.app/addToCart1')
    .then(res => res.json())
    .then(data => setCart(data))
  }, []);
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    const url = `https://carame-cake-server-site.vercel.app/addcartlist?email=${user.email}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => console.log(data));
  }, [user.email]);
  return (
    <>
      <Navbar fixed="top" bg="dark" expand="lg">
        <Container>
          <Navbar.Brand href="/">
            <img src="/logo1.svg" style={{ height: "50px" }} alt="" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto">
              <NavLink
                style={{
                  color: "white",
                  textDecoration: "none",
                  margin: "10px",
                }}
                to="/"
              >
                HOME
              </NavLink>
              <NavLink
                style={{
                  color: "white",
                  textDecoration: "none",
                  margin: "10px",
                }}
                to="/shop"
              >
                SHOP
              </NavLink>
              {/* dropdown */}
              <NavDropdown
                className="navDesign1"
                id="basic-nav-dropdown"
                title={
                  <span style={{
                    color: "white",
                    textDecoration: "none",
                    // margin: "10px",
                  }}>PAGES</span>
                }
                show={show}
                onMouseEnter={showDropdown}
                onMouseLeave={hideDropdown}
              >
                <NavDropdown.Item to="/about">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/about"
                  >
                    About Us
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/contact">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/contact"
                  >
                    Contact Us
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/whatwedo">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/whatwedo"
                  >
                    What we do
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/ourTeam">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/ourTeam"
                  >
                    Our Team
                  </NavLink>
                </NavDropdown.Item>
                <NavDropdown.Item to="/ourProcess">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/ourProcess"
                  >
                    Our Process
                  </NavLink>
                </NavDropdown.Item>
        

                <NavDropdown.Item to="/alldatabase">
                  <NavLink
                    className=""
                    style={{
                      color: "black",
                      textDecoration: "none",
                      margin: "10px",
                    }}
                    to="/alldatabase"
                  >
                    404 Error Page
                  </NavLink>
                </NavDropdown.Item>
              </NavDropdown>
              {/* dropdown */}
              <NavLink
                style={{
                  color: "white",
                  textDecoration: "none",
                  margin: "10px",
                }}
                to="/portfolio"
              >
                PORTFOLIO
              </NavLink>

              {user.email && <NavLink
                style={{
                  color: "white",
                  textDecoration: "none",
                  margin: "10px",
                }}
                to="/dashboard"
              >
                DASHBOARD
              </NavLink>}
            </Nav>
            <Nav>
              <NavLink
                style={{ color: "white", marginRight: "10px" }}
                to="/login"
              >
                <i className="far fa-user"></i>
              </NavLink>
              <NavLink style={{ color: "white", marginRight: "10px" }} to="/">
                <i className="far fa-heart"></i>
              </NavLink>
              {/* <NavLink style={{ color: "white", marginRight: "10px" }} to="/"> */}
              {/* <button class="position-relative cart-btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" > */}
              {/* <button className="cart_btn" >
                    <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                  </button> */}
              {/* <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                  <span class="position-absolute top-0 start-100 translate-middle badge ">
                    0
                    <span class="visually-hidden">unread messages</span>
                  </span>
                </button> */}
              {/* </NavLink> */}
            
              {user.email && (
                <NavLink
                  onClick={logout}
                  style={{ color: "white", marginRight: "20px" }}
                  to="/"
                >
                  <i className="fas fa-sign-out-alt"></i>
                </NavLink>
              )}
                <NavLink
                className=""
                style={{ color: "white",textDecoration:"none" }}
                to="/cart"
              >
                {/* <button className="search_btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"> <i className="fab fa-opencart"></i></button> */}
                CART({cart.length})
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
     
     <div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
     <div className="offcanvas-header">
       <h5 id="offcanvasRightLabel">Total Cart(0)</h5>
       <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
     </div>
     <div className="offcanvas-body">
       <small className="search_text">No products in the cart.</small>
     </div>
   </div>
    </>
  );
};

export default NavBar;
